/* eslint-disable */

import React, { Suspense, useCallback, useContext, useEffect, useRef, useState } from "react";
import { PaycheckContext, ThemeContext } from "../../../../../contexts";
import { useNavigate } from "react-router-dom";
import { Member } from "../../../../../@types/member.types";
import { Validation } from "../../../../../@types/validation.types";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { CommonDetails, Enrollment, StandardDetails } from "../../../../../@types/enrollment.types";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";
import { AdminEnrollmentInitDataQuery } from "../../../../../utils/api/pages/enrollmentInit";
import { Button, MenuItem, Paper, Select } from "@mui/material";
import PlanHeader from "../../../../shared/enrollment/planCode/PlanHeader";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Checkbox, Grid } from "@material-ui/core";
import { CustomInput, CustomSelectInput } from "../../../../shared/customInput";
import {
	dateFormateToMonthDayYear,
	getCurrentDate,
	mongoDBDateParserToUSAFormat
} from "../../../../../utils/commonFunctions/date";
import EventNoteIcon from "@material-ui/icons/EventNote";
import ApproveEnrollmentSection from "./approvalSection/ApprovalSection";
import { ApproveEnrollment } from "../../../../../@types/components/enrollmentProps.types";

import SendIcon from "@material-ui/icons/Send";
import { numberToDollarStr } from "../../../../../utils/commonFunctions/dollar";
import { CoverageDetails } from "../../../../shared/enrollment";
import { Plan, PremiumRateCoverage } from "../../../../../@types/plan.types";
import { CoveredDependents } from "../../../../shared/enrollment/coveredDependents";
import {
	getCurrentActivePlanEligibleDependents,
	getEligibleDependentsOfPlan
} from "../../../../../utils/commonFunctions/groupEnrollment/eligibleDependents";
import { Paycheck } from "../../../../../@types/paycheck.types";
import ReactQuill from "react-quill";
import { getCommonDetails } from "../../../../../utils/commonFunctions/groupEnrollment/enrollmentPayload";
import { RELATIONSHIP } from "../../../../../constants/relationships";
import { set, sub } from "date-fns";
import { p } from "../../../../../constants/allVEBTabsList";
import dateConverterUS from "../../../../../utils/date";
import ExistsEnrollmentModel from "../../../../shared/existsMemberModel/ExistsEnrollmentModel";
import ExistsDependentModel from "../../../../shared/existsMemberModel/ExistsDependentModel";

const ApprovalPlanForm = ({ mode, plan }: any) => {
	// console.log("mpde=====>", mode);
	const { theme, setTheme } = useContext(ThemeContext);
	const navigate = useNavigate();
	const { paycheck, setPaycheck } = useContext(PaycheckContext);
	const [enrollmentDate, setEnrollmentDate] = useState("");
	const [member, setMember] = useState<Member | null>(null);

	const [approveEnrollment, setApproveEnrollment] = useState<ApproveEnrollment>();
	// const [approveHOOEnrollment, setApproveHOOEnrollment] = useState<ApproveHOOEnrollment>();

	const [planName, setPlanName] = useState("");
	const [enrollmentStatus, setEnrollmentStatus] = useState("");
	const [effectiveDate, setEffectiveDate] = useState("");
	// console.log("effectiveDate--", effectiveDate);
	const [currentActivePlanDetails, setCurrentActivePlanDetails] = useState<any>(null);
	const [coverageDetails, setCoverageDetails] = useState<any[]>([]);
	const [eligibleDependents, setEligibleDependents] = useState<(Member & { covered: boolean })[]>([]);
	const [coveredDependents, setCoveredDependents] = useState<(Member & { covered: boolean })[]>([]);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const [isDependentExists, setIsDependentExists] = useState(false);
	const [isModelOpen, setIsModelOpen] = useState(false);

	const [pendingDeselectDependent, setPendingDeselectDependent] = useState<Member | null>(null);
	const [isExistsModelOpen, setIsExistsModelOpen] = useState(false);

	const [dependents, setDependents] = useState<any>([]);

	const [enrollmentStandardDetails, setEnrollmentStandardDetails] = useState<StandardDetails[]>([]);
	const [enrollmentCommonDetail, setEnrollmentCommonDetail] = useState<CommonDetails>();
	const [basePlanCoverage, setBasePlanCoverage] = useState<any>(null);

	const [riderEnrollments, setRiderEnrollments] = useState<Enrollment[] | null>(null);
	const [riderPremiumTotal, setRiderPremiumTotal] = useState<number>(0);
	const [riderPlanCoverage, setRiderPlanCoverage] = useState<any>(null);
	const [riderPlanCoverageDetails, setRiderPlanCoverageDetails] = useState<any[]>([]);
	const [riderPlanEligibleDependents, setRiderPlanEligibleDependents] = useState<(Member & { covered: boolean })[]>(
		[]
	);
	const [riderPlanCoveredDependents, setRiderPlanCoveredDependents] = useState<(Member & { covered: boolean })[]>([]);

	const [enrollments, setEnrollments] = useState<Enrollment[] | null>(null);
	const queryPlanCode = useRouteParam("pc");
	const queryPlanName = useRouteParam("pn");
	const queryGroupNumber = useRouteParam("gn");
	const querySSN = useRouteParam("qs");
	const queryEnrollmentId = useRouteParam("eid");
	const [premiumAmount, setPremiumAmount] = useState<number | null>(null);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [employeePremium, setEmployeePremium] = useState<number>(0);
	const [dependentPremium, setDependentPremium] = useState<number>(0);
	const [validation, setValidation] = useState<Validation>({
		approveHOOEnrollment: {},
		status: "invalid"
	});
	const _validation = useRef<Validation>();

	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	// const handleSubmitEnrollmentClick = useCallback(
	// 	async (event: React.FormEvent<HTMLButtonElement>) => {
	// 		// console.log("approve", approveHOOEnrollment);
	// 		// eslint-disable-next-line @typescript-eslint/no-unused-vars
	// 		const validation = await handleValidation();
	// 		// console.log("validation", validation);
	// 		if (validation === "valid") {
	// 			if (approveHOOEnrollment === undefined) {
	// 				return;
	// 			}

	// 			const { effective_date } = approveHOOEnrollment;

	// 			const effectiveDate = new Date(effective_date as unknown as Date);

	// 			const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = {
	// 				...approveHOOEnrollment,
	// 				effective_date:
	// 					effectiveDate.getFullYear() + "-" + (effectiveDate.getMonth() + 1) + "-" + effectiveDate.getDate()
	// 			};
	// 			const response = await trackPromise(api.enrollments.approveHOOEnrollment(approveHOOEnrollmentPayload));

	// 			// console.log("response", response);
	// 			if (response) {
	// 				const { enrollment_status } = response;

	// 				enrollment_status === ENROLLMENT_STATUS.active
	// 					? alert("Helping Our Own launch enrollment Submitted!")
	// 					: enrollment_status === ENROLLMENT_STATUS.rejected
	// 					? alert("Helping Our Own launch enrollment has been Rejected!")
	// 					: alert(null);

	// 				handleMemberDetailsRedirection();
	// 			}
	// 		}
	// 		// if (approveHOOEnrollment === undefined) {
	// 		// 	return;
	// 		// }
	// 		// const approveHOOEnrollmentPayload: ApproveHOOEnrollmentPayload = approveHOOEnrollment;
	// 		// const response = await api.enrollments.approveHOOEnrollment(approveHOOEnrollmentPayload);
	// 		// if (response) {
	// 		// 	navigate(-1);
	// 		// }
	// 	},
	// 	[approveHOOEnrollment, handleMemberDetailsRedirection, handleValidation]
	// );

	// const handleApproveEnrollmentDateChange = useCallback(
	// 	(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
	// 		const selectedDate = new Date(date as any);

	// 		const parsedDate =
	// 			selectedDate.getFullYear() + "-" + (selectedDate.getMonth() + 1) + "-" + selectedDate.getDate();

	// 		setApproveHOOEnrollment(
	// 			Object.assign({}, approveHOOEnrollment, {
	// 				effective_date: parsedDate
	// 			})
	// 		);
	// 	},
	// 	[approveHOOEnrollment]
	// );

	// eslint-disable-next-line arrow-parens
	const handleApproveEffectiveDateChange = useCallback((_date: any) => {
		const date = new Date(_date);
		// const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		const parsedDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
		console.log("date--", parsedDate);
		setEffectiveDate(parsedDate);
	}, []);

	const getEligibleDependents = useCallback(
		(
			_coveredDependents: Member[],
			_notCoveredDependents: Member[],
			plan: Plan & { dependent_eligibility: any }
		) => {
			if (plan === undefined) {
				return;
			}
			// console.log("tttttttttttt 2", plan.coverage);
			const _eligibleDependents = getEligibleDependentsOfPlan(
				_notCoveredDependents,
				plan.coverage,
				plan.dependent_eligibility
			);
			const notCoveredEligibleDependents = _eligibleDependents.map((dependents: Member) => ({
				...dependents,
				covered: false
			}));
			const coveredEligibleDependents = _coveredDependents.map((dependents: Member) => ({
				...dependents,
				covered: true
			}));
			setCoveredDependents(Object.assign([], coveredEligibleDependents));
			setEligibleDependents(Object.assign([], [...notCoveredEligibleDependents, ...coveredEligibleDependents]));
		},
		[]
	);

	const getDependents = useCallback(
		(
			enrollments: Enrollment[],
			dependents: Member[],
			employeeSSN: string,
			paycheck: Paycheck,
			currentActivePlanDetails: any
		) => {
			const coveredDependentSSNs: string[] = [];
			const _coveredDependents: Member[] = [];
			// setPlan(Object.assign({}, enrollments[0].plan));
			console.log("test 2", enrollments);
			if (paycheck === null) {
				return;
			}
			enrollments.forEach((enrollment: Enrollment) => {
				const {
					_id,
					insured_SSN,
					plan_code,
					enrollment_date,
					member_SSN,
					premium_amount,
					enrollment_status,
					effective_date,
					employee
				} = enrollment;
				// console.log("enrollment ==========>", enrollment);
				if (member_SSN !== employeeSSN) {
					coveredDependentSSNs.push(member_SSN);
				} else {
					setMember(Object.assign({}, employee));
					setApproveEnrollment((prevApproveEnrollment: ApproveEnrollment | undefined) =>
						Object.assign({}, prevApproveEnrollment, {
							_id,
							plan_code,
							insured_SSN,
							current_paycheck_id: paycheck._id,
							enrollment_status
						})
					);

					// console.log("testingggggg", enrollment_date);
					setEnrollmentCommonDetail(getCommonDetails(enrollment));
					setEnrollmentDate(enrollment_date as unknown as string);
				}
			});
			// console.log("coveredDependentSSNs", coveredDependentSSNs);
			const _notCoveredDependents: Member[] = [];
			dependents.map((dependent: Member) => {
				if (coveredDependentSSNs.includes(dependent.SSN)) {
					// console.log("dependent.SSN", dependent.SSN);
					_coveredDependents.push(dependent);
				} else {
					_notCoveredDependents.push(dependent);
				}
			});
			// console.log("_coveredDependents", _coveredDependents);
			// console.log("_notCoveredDependents", _notCoveredDependents);
			//setCoveredDependents(Object.assign([], _coveredDependents));
			//setNotCoveredDependents(Object.assign([], _notCoveredDependents));
			if (enrollments[0].plan === undefined) {
				return;
			}

			if (_coveredDependents.length > 0 || _notCoveredDependents.length > 0) {
				getEligibleDependents(_coveredDependents, _notCoveredDependents, currentActivePlanDetails as any);
			}
		},
		[getEligibleDependents]
	);

	const getDependentsForRider = useCallback(
		(
			enrollments: Enrollment[],
			dependents: Member[],
			plan: any,
			currentActivePlanDetails: any,
			employeeSSN: string
		) => {
			const coveredDependentSSNs: string[] = [];
			const _coveredDependents: Member[] = [];
			// setPlan(Object.assign({}, enrollments[0].plan));
			// console.log(plan, "test 2 rider i am called ", enrollments);

			// if (paycheck === null) {
			// 	return;
			// }
			enrollments.forEach((enrollment: Enrollment) => {
				const {
					_id,
					insured_SSN,
					plan_code,
					enrollment_date,
					member_SSN,
					premium_amount,
					enrollment_status,
					effective_date,
					employee
				} = enrollment;
				if (member_SSN !== employeeSSN) {
					coveredDependentSSNs.push(member_SSN);
				} else {
					// setMember(Object.assign({}, employee));
					// setApproveEnrollment((prevApproveEnrollment: ApproveEnrollment | undefined) =>
					// 	Object.assign({}, prevApproveEnrollment, {
					// 		_id,
					// 		plan_code,
					// 		insured_SSN,
					// 		current_paycheck_id: paycheck._id,
					// 		enrollment_status,
					// 		effective_date
					// 	})
					// );
					// setEnrollmentCommonDetail(getCommonDetails(enrollment));
					// setEnrollmentDate(enrollment_date as unknown as string);
				}
			});

			// console.log("coveredDependentSSNs", coveredDependentSSNs);
			const _notCoveredDependents: Member[] = [];
			dependents.map((dependent: Member) => {
				if (coveredDependentSSNs.includes(dependent.SSN)) {
					// console.log("dependent.SSN", dependent.SSN);
					_coveredDependents.push(dependent);
				} else {
					_notCoveredDependents.push(dependent);
				}
			});
			// console.log("_coveredDependents", _coveredDependents);
			// console.log("_notCoveredDependents", _notCoveredDependents);
			//setCoveredDependents(Object.assign([], _coveredDependents));
			//setNotCoveredDependents(Object.assign([], _notCoveredDependents));
			// console.log(_coveredDependents, "doing", plan, "test 2 3 4", _notCoveredDependents, enrollments[0].plan);
			if ((_coveredDependents.length > 0 || _notCoveredDependents.length > 0) && enrollments[0].plan) {
				if (plan === undefined) {
					return;
				}
				const _eligibleDependents = getEligibleDependentsOfPlan(
					_notCoveredDependents,
					plan.coverage,
					currentActivePlanDetails.dependent_eligibility
				);
				// if (_eligibleDependents && _eligibleDependents.length > 0) {
				const notCoveredEligibleDependents = _eligibleDependents.map((dependents: Member) => ({
					...dependents,
					covered: false
				}));
				const coveredEligibleDependents = _coveredDependents.map((dependents: Member) => ({
					...dependents,
					covered: true
				}));
				setRiderPlanCoveredDependents(Object.assign([], coveredEligibleDependents));
				setRiderPlanEligibleDependents(
					Object.assign([], [...notCoveredEligibleDependents, ...coveredEligibleDependents])
				);
				// }
			}
		},
		[]
	);

	const calculateRiderTotalPremium = useCallback(
		(riderEnrollments: Enrollment[], currentActivePlanDetails: any): any => {
			let totalRiderPremium: any = 0;
			let riderplanCoverage: any = null;

			// VEB-structured plans keep a single rider on `rider` (VEB shape) rather than in
			// `internal_dependencies` (core shape), and it has no core `coverage` table. Its
			// rows are already priced at enrolment, so just total them and leave
			// riderPlanCoverage null — that keeps the core re-pricing block from running.
			if (currentActivePlanDetails?.same_as_veb_structure) {
				totalRiderPremium =
					riderEnrollments.reduce((accumulator: any, riderEnrollment: Enrollment) => {
						return riderEnrollment.premium_amount + accumulator;
					}, 0) || 0;

				setRiderPremiumTotal(totalRiderPremium);
				return totalRiderPremium;
			}

			const riderPlan = currentActivePlanDetails?.internal_dependencies?.find(
				(riderPlan: any) =>
					riderPlan.sub_plan.name === riderEnrollments[0].plan_name && riderPlan.sub_plan.required == false
			);

			if (!riderPlan) {
				alert("Rider plan details not found in the current active plan details");
				return null;
			} else {
				if (riderPlan.sub_plan.coverage.premium_without_dependent) {
					totalRiderPremium =
						riderEnrollments.reduce((accumulator: any, riderEnrollment: Enrollment) => {
							return riderEnrollment.premium_amount + accumulator;
						}, 0) || 0;
				} else {
					totalRiderPremium = riderEnrollments[0].premium_amount;
				}

				setRiderPlanCoverage(riderPlan.sub_plan);
				setRiderPremiumTotal(totalRiderPremium);
				return totalRiderPremium;
			}
		},
		[]
	);

	const getAdminEnrollmentInitData = useCallback(async () => {
		if (!queryGroupNumber || !queryPlanCode || !querySSN) {
			return;
		}
		//getAdminEnrollmentInitData();
		const query: AdminEnrollmentInitDataQuery = {
			insured_SSN: querySSN as string,
			plan_code: queryPlanCode as string,
			group_number: queryGroupNumber as number,
			plan_name: queryPlanName as string
		};
		const { dependents, theme, enrollments, paycheck, currentActivePlanDetails } = await trackPromise(
			api.pages.getAdminEnrollmentInitData(query)
		);
		console.log("test", dependents, "::", theme, enrollments, paycheck, currentActivePlanDetails);
		// getDependents(enrollments, dependents, querySSN as string, paycheck);
		const baseEnrollments = enrollments.filter(
			(enrollment: Enrollment) => enrollment.base_plan_name === enrollment.plan_name
		);
		setCurrentActivePlanDetails(currentActivePlanDetails);
		setEnrollments(Object.assign([], baseEnrollments));

		const riderEnrollments = enrollments.filter(
			(enrollment: Enrollment) => enrollment.base_plan_name !== enrollment.plan_name
		);

		let riderTotalPremium: any = 0;

		if (riderEnrollments && riderEnrollments.length > 0 && currentActivePlanDetails) {
			setRiderEnrollments(Object.assign([], riderEnrollments));

			riderTotalPremium = calculateRiderTotalPremium(riderEnrollments, currentActivePlanDetails);
		}

		// riderEnrollments.forEach((riderEnrollment:Enrollment)=>{

		const { enrollment_status, enrollment_date, plan_name } = enrollments[0];
		if (!enrollments[0].sub_plan) {
			// console.log("getDependents called 00", enrollments);
			setBasePlanCoverage(enrollments[0].plan);
		} else if (enrollments[0].sub_plan && enrollments[0].plan) {
			const basePlan = currentActivePlanDetails?.internal_dependencies?.find((sub_plan: any) => {
				// console.log(
				// 	sub_plan.sub_plan.name,
				// 	"basePlan 2",
				// 	enrollments[0].sub_plan,
				// 	"reuired",
				// 	sub_plan.sub_plan.required
				// );
				return sub_plan.sub_plan.name == enrollments[0].sub_plan && sub_plan.sub_plan.required == true;
			});
			console.log(currentActivePlanDetails?.internal_dependencies, "basePlan", basePlan);
			// A VEB-structured plan has no internal_dependencies — its sub_plan is a coverage
			// volume, not a base-plan variant — so fall back to the enrollment's own plan.
			setBasePlanCoverage(basePlan ? basePlan.sub_plan : enrollments[0].plan);
		}

		setDependents(dependents);
		setPremiumAmount(enrollments[0].premium_amount);
		if (enrollments && enrollments.length > 0) {
			setTotalPremium(
				enrollments[0].total_premium ? enrollments[0].total_premium : enrollments[0].premium_amount
			);
		}

		// setApproveHOOEnrollment(
		// 	Object.assign(
		// 		{},
		// 		{
		// 			group_number: queryGroupNumber as number,
		// 			current_paycheck_id: paycheck._id as string,
		// 			_id: enrollments[0]._id as string,
		// 			plan_code: enrollments[0].plan_code,
		// 			insured_SSN: enrollments[0].employee?.SSN as string,
		// 			premium_amount: enrollments[0].premium_amount,
		// 			effective_date: enrollments[0].effective_date
		// 				? (enrollments[0].effective_date as unknown as string)
		// 				: null,
		// 			enrollment_status: enrollments[0].enrollment_status
		// 		}
		// 	)
		// );
		// console.log("enrollments[0]", enrollments[0].enrollment_date);
		// console.log("testingggggg", enrollment_date);
		setEnrollmentDate(enrollments[0].enrollment_date as unknown as string);

		setMember(Object.assign({}, enrollments[0].employee));
		setTheme(Object.assign({}, theme));
		setEnrollmentStatus(enrollment_status);
		setPlanName(plan_name);
		setPaycheck(Object.assign({}, paycheck));
		if (enrollments[0]?.open_enrollment) {
			if (enrollments[0]?.open_enrollment.type == "YEARLY")
				handleApproveEffectiveDateChange(enrollments[0]?.plan?.start_date);
		} else {
			handleApproveEffectiveDateChange(new Date());
		}
	}, [queryGroupNumber, queryPlanCode, querySSN, setPaycheck, setTheme]);

	const handleApproveEnrollmentChange = useCallback(
		(
			event: React.ChangeEvent<
				| HTMLInputElement
				| {
						name?: string | undefined;
						value: unknown;
				  }
			>,
			child?: React.ReactNode
		) => {
			const { name, value } = event.target;
			console.log(name, "test", value);
			setApproveEnrollment(
				Object.assign({}, approveEnrollment, {
					[name as string]: value
				})
			);
		},
		[approveEnrollment]
	);

	const handleApproveEnrollmentDateChange = useCallback(
		(date?: MaterialUiPickersDate, value?: string | null | undefined) => {
			const parsedDate = date as unknown as string;
			setApproveEnrollment(Object.assign({}, approveEnrollment, { effective_date: parsedDate }));
		},
		[approveEnrollment]
	);
	const handleMemberDetailsRedirection = useCallback(() => {
		const pathname = `/employer/member?gn=${queryGroupNumber}&&qs=${
			encryption(querySSN as string) as string
		}&&to=benefits`;
		navigate(pathname);
	}, [navigate, queryGroupNumber, querySSN]);
	// const handleRedirectToMemberDetails = useCallback(() => {
	// 	// const pathname = `/employer/member?${routeQueryParam[0]}&${routeQueryParam[2]}`;
	// 	navigate(pathname);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	// const approveDynamicEnrollmentFormat = [
	// 	plan_code,
	// 	open_enrollment_id,
	// 	insured_SSN,
	// 	Dependents,
	// 	PREMIUM_AMOUNT,
	// 	totalPremiumAmount,
	// 	effective_dates,
	// 	enrollmentDate,
	// 	enrollment_status,
	// 	current_paycheck_id
	// ];

	const handleSubmitEnrollmentClick = useCallback(async () => {
		if (!queryEnrollmentId || !enrollments || enrollments.length == 0) return;
		if (!effectiveDate) {
			alert("Effective date is required");
			return;
		}
		// if (
		// 	!(
		// 		enrollmentStatus?.toLowerCase() == "rejected".toLowerCase() ||
		// 		enrollmentStatus?.toLowerCase() == "active".toLowerCase()
		// 	)
		// ) {
		// 	alert("status is required!");
		// 	return;
		// }
		try {
			if (
				approveEnrollment === undefined
				//  || enrollmentCommonDetail === undefined
			) {
				console.log("noapproveenrollment", approveEnrollment);
				return;
			}
			// const approveEnrollmentPayload: any = {
			// 	plan_code: enrollments[0].plan_code,
			// 	open_enrollment_id: enrollments[0].open_enrollment_id,
			// 	insured_SSN: enrollments[0].insured_SSN,
			// 	dependentsEnrollmentDetails: enrollmentStandardDetails,
			// 	commonEnrollmentDetails: enrollmentCommonDetail,
			// 	// effectiveDate: effectiveDate,
			// 	// enrollmentDate: enrollmentDate,
			// 	enrollmentStatus: enrollmentStatus,
			// 	currentPaycheck_id: paycheck?._id
			// };

			// const { effective_date } = approveEnrollment;
			const effectiveDateModified = new Date(effectiveDate as unknown as Date);
			const _approveEnrollmentPayload = {
				...approveEnrollment,
				effective_date:
					effectiveDateModified.getFullYear() +
					"-" +
					(effectiveDateModified.getMonth() + 1) +
					"-" +
					effectiveDateModified.getDate()
			};
			const enrollment: any = enrollments.filter(
				(enrollment: any) => enrollment.insured_SSN == enrollment.member_SSN
			);
			const approveEnrollmentPayload: any = {
				..._approveEnrollmentPayload,
				// enrollment_status: enrollmentStatus,
				common_detail: {
					...getCommonDetails(enrollment[0]),
					total_premium: totalPremium,
					premium_amount: employeePremium
				},
				dependent_standard_details: enrollmentStandardDetails,
				covered_dependent_SSNs: coveredDependents.map(({ SSN }: Member) => SSN)
			};
			// console.log("passed=====>", approveEnrollmentPayload);
			// return;

			const response = await trackPromise(api.enrollments.approveDynamicEnrollment(approveEnrollmentPayload));
			// const response = approveEnrollmentPayload?.plan?.is_always_open
			// 	? await trackPromise(api.enrollments.approveHOOEnrollment(approveEnrollmentPayload))
			// 	: await trackPromise(api.enrollments.approveDynamicEnrollment(approveEnrollmentPayload));
			// console.log("response===>", response);
			if (response) {
				if (response.result.enrollment_status === "SUBMITTED") {
					alert(`${planName} Plan Approval Submitted!`);
				}
				if (response.result.enrollment_status === "REJECTED") {
					alert(`${planName} Plan Approval has been Rejected!`);
				}

				handleMemberDetailsRedirection();
			}
		} catch (error) {
			// console.error("Error during plan approve enrollment submission:", error);
			alert("Plan Approve Enrollment Submission unsuccessful!");
			throw error;
		}
	}, [
		effectiveDate,
		// enrollments,
		// enrollmentStatus,
		// enrollmentDate,
		paycheck,
		planName,
		queryEnrollmentId,
		enrollmentCommonDetail,
		enrollmentStandardDetails,
		approveEnrollment,
		totalPremium,
		employeePremium,
		enrollments,
		coveredDependents,
		handleMemberDetailsRedirection
	]);
	// console.log("enrollments", enrollments);
	const getPremiumAmount = useCallback(
		(premiumRateCoverage: any): string => {
			let premiumAmount = "";
			if (paycheck) {
				// find the matching premium for the paycheck's frequency
				const premiumObj = premiumRateCoverage.premiums?.find(
					// eslint-disable-next-line
					(p: any) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
				);

				if (!premiumObj || premiumObj.value == null) {
					return premiumAmount;
				}

				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount = `${numberToDollarStr(Number(premiumObj.value))}`;
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount = `${premiumObj.value}%`;
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);
	const getPremiumAmountByCoverage = useCallback(
		(premiumRateCoverage: any): number | string => {
			console.log("premiumRateCoverage=====>", premiumRateCoverage);
			let premiumAmount: number | string = "";
			if (paycheck) {
				// find the matching premium for the paycheck's frequency
				const premiumObj = premiumRateCoverage.premiums?.find(
					// eslint-disable-next-line
					(p: any) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
				);

				if (!premiumObj || premiumObj.value == null) {
					return premiumAmount;
				}

				if (premiumRateCoverage.premium_type === "FIXED") {
					premiumAmount = Number(premiumObj.value);
				} else if (premiumRateCoverage.premium_type === "PERCENTAGE") {
					premiumAmount = Number(premiumObj.value);
				}
			}
			return premiumAmount;
		},
		[paycheck]
	);

	const getCoverageDetails = useCallback(() => {
		const _coverageDetails: any[] = [];

		if (paycheck === null || basePlanCoverage === undefined) {
			return;
		}
		const { coverage } = basePlanCoverage;
		// if (coverage.EE?.active === true) {
		// 	const premiumAmount = getPremiumAmount(coverage.EE);

		// 	_coverageDetails.push({
		// 		coverage: "Employee Only",
		// 		premiumAmount
		// 	});
		// }
		// if (coverage.ED?.active) {
		// 	_coverageDetails.push({
		// 		coverage: "Coverage For All Dependent irrespective of relationship type",
		// 		premiumAmount: getPremiumAmount(coverage.ED)
		// 	});
		// } else {
		// 	if (coverage.ES?.active === true) {
		// 		const premiumAmount = getPremiumAmount(coverage.ES);
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Spouse",
		// 			premiumAmount
		// 		});
		// 	}
		// 	if (coverage.EC?.active === true) {
		// 		const premiumAmount = getPremiumAmount(coverage.EC);
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For One Child",
		// 			premiumAmount
		// 		});
		// 	}
		// 	if (coverage.ECH?.active === true) {
		// 		const premiumAmount = getPremiumAmount(coverage.ECH);
		// 		_coverageDetails.push({
		// 			coverage: "Coverage For Two or More Children",
		// 			premiumAmount
		// 		});
		// 	}
		// }
		const coverageConfig = [
			{
				key: "EE",
				label: "Employee Only"
			},
			{
				key: "ES",
				label: "Coverage For Spouse"
			},
			{
				key: "EC",
				label: "Coverage For One Child"
			},
			{
				key: "ECH",
				label: "Coverage For Children(s)"
			},
			{
				key: "ED",
				label: "Coverage For All Dependent irrespective of relationship type"
			}
		];

		coverageConfig.forEach(({ key, label }) => {
			if (coverage?.[key]?.active) {
				_coverageDetails.push({
					coverage: label,
					premiumAmount: getPremiumAmount(coverage[key])
				});
			}
		});
		setCoverageDetails(Object.assign([], _coverageDetails));
	}, [getPremiumAmount, paycheck, basePlanCoverage]);

	const checkMemberEnrollment = async (member: Member) => {
		const selectedMemberSSN = member?.SSN;
		const employee_SSN = member?.employee_SSN;
		const payload = {
			member_SSN: selectedMemberSSN,
			employee_SSN: employee_SSN
		};

		if (!selectedMemberSSN) {
			console.error("No SSN found");
			return false;
		}

		try {
			const response = await api.member.getExistsMemberEnrollemnt(payload);
			if (response) {
				setIsDependentExists(true);
				setExistsDependentData(response.member);
				setPendingDeselectDependent(member); // Store the dependent that needs deselection
				setIsExistsModelOpen(true); // Open the modal
				return true;
			}
			return false;
		} catch (err) {
			console.error("Error:", err);
			return false;
		}
	};

	// const checkMemberEnrollment = async (member: Member) => {
	// 	const selectedMemberSSN = member?.SSN;
	// 	// console.log("selectedMemberSSN", selectedMemberSSN);
	// 	const employee_SSN = member?.employee_SSN;
	// 	const payload = {
	// 		member_SSN: selectedMemberSSN,
	// 		employee_SSN: employee_SSN
	// 	};

	// 	if (!selectedMemberSSN) {
	// 		console.error("No SSN found");
	// 		return;
	// 	}

	// 	try {
	// 		// console.log("APIPAYLOAD--->", selectedMemberSSN);

	// 		const response = await api.member.getExistsMemberEnrollemnt(payload);
	// 		if (response) {
	// 			setIsDependentExists(true);
	// 			setExistsDependentData(response.member);
	// 			setIsModelOpen(true);
	// 			return true;
	// 		}
	// 		// console.log("APIRESPONSEFORTHEHEALTH", response);
	// 	} catch (err) {
	// 		console.error("Error:", err);
	// 	}
	// };

	const handleConfirmDeselect = useCallback(() => {
		if (pendingDeselectDependent) {
			// Uncheck the dependent - this reverses the selection
			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => pendingDeselectDependent.SSN !== selectedDependent.SSN
				);
				return _selectedDependents;
			});

			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
				const newEligibleDependents = prevEligibleDependents.map(
					(prevEligibleDependent: Member & { covered: boolean }) => {
						if (pendingDeselectDependent.SSN === prevEligibleDependent.SSN) {
							return { ...pendingDeselectDependent, covered: false };
						} else {
							return prevEligibleDependent;
						}
					}
				);
				return newEligibleDependents;
			});
		}

		// Reset states
		setPendingDeselectDependent(null);
		setIsExistsModelOpen(false);
		setIsDependentExists(false);
	}, [pendingDeselectDependent]);

	const handleSelectDependent = useCallback(async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
		const { checked } = event.target;
		if (checked === true) {
			await checkMemberEnrollment(dependent);
			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) =>
				Object.assign([], [...prevCoveredDependents, { ...dependent, covered: true }])
			);
			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
				const newEligibleDependents = prevEligibleDependents.map(
					(prevEligibleDependent: Member & { covered: boolean }) => {
						if (dependent.SSN === prevEligibleDependent.SSN) {
							return { ...dependent, covered: true };
						} else {
							return prevEligibleDependent;
						}
					}
				);
				return newEligibleDependents;
			});
		} else {
			setIsDependentExists(false);
			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
				const _selectedDependents = prevCoveredDependents.filter(
					(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
				);
				// console.log("selectedDependent", _selectedDependents);
				return _selectedDependents;
			});
			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
				const newEligibleDependents = prevEligibleDependents.map(
					(prevEligibleDependent: Member & { covered: boolean }) => {
						if (dependent.SSN === prevEligibleDependent.SSN) {
							return { ...dependent, covered: false };
						} else {
							return prevEligibleDependent;
						}
					}
				);
				return newEligibleDependents;
			});
		}
	}, []);

	// const handleSelectDependent = useCallback(async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
	// 	const { checked } = event.target;

	// 	console.log("==========================================");
	// 	console.log("handleSelectDependent CALLED");
	// 	console.log("Dependent:", dependent.first_name, dependent.last_name, "SSN:", dependent.SSN);
	// 	console.log("Checkbox checked:", checked);
	// 	console.log("Current coveredDependents count:", coveredDependents.length);
	// 	console.log("==========================================");

	// 	if (checked === true) {
	// 		console.log("Attempting to ADD dependent...");

	// 		// Check if member already exists in another enrollment
	// 		const exists = await checkMemberEnrollment(dependent);
	// 		console.log("checkMemberEnrollment returned:", exists);

	// 		// Only add to covered dependents if member does NOT exist
	// 		if (!exists) {
	// 			console.log("Dependent does NOT exist elsewhere - ADDING to coveredDependents");

	// 			setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
	// 				const newState = [...prevCoveredDependents, { ...dependent, covered: true }];
	// 				console.log("New coveredDependents count:", newState.length);
	// 				return newState;
	// 			});

	// 			setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
	// 				const newEligibleDependents = prevEligibleDependents.map(
	// 					(prevEligibleDependent: Member & { covered: boolean }) => {
	// 						if (dependent.SSN === prevEligibleDependent.SSN) {
	// 							return { ...dependent, covered: true };
	// 						} else {
	// 							return prevEligibleDependent;
	// 						}
	// 					}
	// 				);
	// 				return newEligibleDependents;
	// 			});

	// 			console.log("Dependent ADDED successfully");
	// 		} else {
	// 			console.log("Dependent EXISTS in other enrollment - BLOCKING selection, showing modal");
	// 			// IMPORTANT: Force the checkbox to uncheck since we're blocking this selection
	// 			event.target.checked = false;
	// 		}
	// 	} else {
	// 		console.log("Attempting to REMOVE dependent...");

	// 		setIsDependentExists(false);
	// 		setCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
	// 			const _selectedDependents = prevCoveredDependents.filter(
	// 				(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
	// 			);
	// 			console.log("Removed dependent, new count:", _selectedDependents.length);
	// 			return _selectedDependents;
	// 		});

	// 		setEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
	// 			const newEligibleDependents = prevEligibleDependents.map(
	// 				(prevEligibleDependent: Member & { covered: boolean }) => {
	// 					if (dependent.SSN === prevEligibleDependent.SSN) {
	// 						return { ...dependent, covered: false };
	// 					} else {
	// 						return prevEligibleDependent;
	// 					}
	// 				}
	// 			);
	// 			return newEligibleDependents;
	// 		});

	// 		console.log("Dependent REMOVED successfully");
	// 	}

	// 	console.log("handleSelectDependent COMPLETED");
	// 	console.log("==========================================");
	// }, [checkMemberEnrollment, coveredDependents.length]);

	const handleSelectDependentForRider = useCallback(
		async (event: React.ChangeEvent<HTMLInputElement>, dependent: Member) => {
			const { checked } = event.target;
			if (checked === true) {
				setRiderPlanCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) =>
					Object.assign([], [...prevCoveredDependents, { ...dependent, covered: true }])
				);
				setRiderPlanEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
					const newEligibleDependents = prevEligibleDependents.map(
						(prevEligibleDependent: Member & { covered: boolean }) => {
							if (dependent.SSN === prevEligibleDependent.SSN) {
								return { ...dependent, covered: true };
							} else {
								return prevEligibleDependent;
							}
						}
					);
					return newEligibleDependents;
				});
			} else {
				setIsDependentExists(false);
				setRiderPlanCoveredDependents((prevCoveredDependents: (Member & { covered: boolean })[]) => {
					const _selectedDependents = prevCoveredDependents.filter(
						(selectedDependent: Member) => dependent.SSN !== selectedDependent.SSN
					);
					// console.log("selectedDependent", _selectedDependents);
					return _selectedDependents;
				});
				setRiderPlanEligibleDependents((prevEligibleDependents: (Member & { covered: boolean })[]) => {
					const newEligibleDependents = prevEligibleDependents.map(
						(prevEligibleDependent: Member & { covered: boolean }) => {
							if (dependent.SSN === prevEligibleDependent.SSN) {
								return { ...dependent, covered: false };
							} else {
								return prevEligibleDependent;
							}
						}
					);
					return newEligibleDependents;
				});
			}
		},
		[]
	);

	const formDeclaration = plan?.form_design?.form_declaration || "";
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = formDeclaration;
	const plainText = tempDiv.textContent?.trim() || "";

	const getRiderPlanCoverageDetails = useCallback(
		(coverage: any) => {
			if (paycheck === null || !coverage) {
				return;
			}
			const _coverageDetails: any[] = [];

			if (coverage.EE?.active) {
				_coverageDetails.push({
					coverage: "Employee Only",
					premiumAmount: getPremiumAmount(coverage.EE)
				});
			}
			if (coverage.ED?.active) {
				_coverageDetails.push({
					coverage: "Coverage For All Dependent irrespective of relationship type",
					premiumAmount: getPremiumAmount(coverage.ED)
				});
			} else {
				if (coverage.ES?.active) {
					_coverageDetails.push({
						coverage: "Coverage For Spouse",
						premiumAmount: getPremiumAmount(coverage.ES)
					});
				}
				if (coverage.EC?.active) {
					_coverageDetails.push({
						coverage: "Coverage For One Child",
						premiumAmount: getPremiumAmount(coverage.EC)
					});
				}
				if (coverage.ECH?.active) {
					_coverageDetails.push({
						coverage: "Coverage For Two or More Children",
						premiumAmount: getPremiumAmount(coverage.ECH)
					});
				}
			}
			setRiderPlanCoverageDetails(_coverageDetails);

			// const dependentCoverage: any = getEligibleDependents(
			// 	dependents,
			// 	coverage,
			// 	currentActivePlanDetails.dependent_eligibility
			// );
			// // console.log("dependentCoverage for subplan===>", dependentCoverage);
			// setRiderPlanEligibleDependents([...dependentCoverage.eligibleDependents]);
		},
		[getPremiumAmount, dependents, paycheck]
	);

	const getPremiumRateByFixed = useCallback(
		(basePayRate: number, premiumRateCoverage: PremiumRateCoverage | any): number | null => {
			if (paycheck) {
				// find the matching premium for the paycheck's frequency
				let premiumAmount = 0;
				const premiumObj = premiumRateCoverage.premiums?.find(
					// eslint-disable-next-line
					(p: any) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
				);

				if (!premiumObj || premiumObj.value == null) {
					return premiumAmount;
				}

				premiumAmount = Number(premiumObj.value);

				return premiumAmount;
			} else {
				return null;
			}
		},
		[paycheck]
	);

	const getPremiumRateByPercentage = useCallback(
		(basePayRate: number, premiumRateCoverage: PremiumRateCoverage | any): number | null => {
			if (paycheck === null) {
				return null;
			}
			let premiumAmount: number | null = null;
			// if (paycheck.pay_frequency === "MONTHLY") {
			// 	premiumAmount = (basePayRate * ((coverageCode.monthly_premium as number) / 100)) as number;
			// 	if (premiumAmount > (coverageCode.monthly_maximum_premium as number)) {
			// 		premiumAmount = coverageCode.monthly_maximum_premium as number;
			// 	} else if (premiumAmount < (coverageCode.monthly_minimum_premium as number)) {
			// 		premiumAmount = coverageCode.monthly_minimum_premium as number;
			// 	}
			// } else if (paycheck.pay_frequency === "WEEKLY") {
			const coverageCode = premiumRateCoverage.premiums?.find(
				// eslint-disable-next-line
				(p: any) => p.pay_frequency.toLowerCase() === paycheck.pay_frequency.toLowerCase()
			);
			premiumAmount = (basePayRate * ((coverageCode.value as number) / 100)) as number;
			if (premiumAmount > (coverageCode.maximum as number)) {
				premiumAmount = coverageCode.maximum as number;
			} else if (premiumAmount < (coverageCode.minimum as number)) {
				premiumAmount = coverageCode.minimum as number;
			}
			// }
			return premiumAmount;
		},
		[paycheck]
	);
	const getPremiumAmountRateByCoverage = useCallback(
		(basePayRate: number, coverageCode: PremiumRateCoverage | any): number | null => {
			if (paycheck === null) {
				return null;
			}

			let premiumAmount: number | null;
			if (coverageCode.active === false) {
				alert("Member is not covered in this plan");
				return null;
			}
			if (coverageCode.premium_type === "PERCENTAGE") {
				premiumAmount = getPremiumRateByPercentage(basePayRate, coverageCode);
			} else if (coverageCode.premium_type === "FIXED") {
				premiumAmount = getPremiumRateByFixed(basePayRate, coverageCode);
			} else {
				alert("Invalid premium type");
				return null;
			}
			return premiumAmount;
		},
		[getPremiumRateByFixed, getPremiumRateByPercentage, paycheck]
	);

	// const calculateCombinedCoverageCode = useCallback((coveredDependents: any) => {
	// 	let coverage_code = "EE";

	// 	let relationshipList = coveredDependents.map((dependent: any) => dependent.relationship.toLowerCase());

	// 	if (
	// 		relationshipList.includes("spouse") &&
	// 		(relationshipList.includes("child") || relationshipList.includes("children"))
	// 	) {
	// 		coverage_code = "EF";
	// 	} else if (relationshipList.includes("spouse")) {
	// 		coverage_code = "ES";
	// 	} else if (
	// 		relationshipList.includes("children") ||
	// 		relationshipList.filter((relationship: any) => relationship == "child").length > 1
	// 	) {
	// 		coverage_code = "ECH";
	// 	} else if (
	// 		relationshipList.includes("child") &&
	// 		relationshipList.filter((relationship: any) => relationship == "child").length == 1
	// 	) {
	// 		coverage_code = "EC";
	// 	} else if (relationshipList.length > 0) {
	// 		// alert("some critical relationship found not included in premium");
	// 		console.log("some critical relationship found not included in premium");
	// 	}
	// 	return coverage_code;
	// }, []);
	const calculateCombinedCoverageCode = useCallback((coveredDependents: any, planDetails: any) => {
		// console.log(coveredDependents, "coveredDependents=====>", planDetails);

		const childRelationships = ["court-ordered dependent", "others"];

		let coverage_code = "EE";

		let relationshipList = coveredDependents.map((dependent: any) => dependent.relationship.toLowerCase());

		// console.log("relationshipList=====>", relationshipList);

		const childCount = relationshipList.filter(
			(relationship: any) => relationship.includes("child") || childRelationships.includes(relationship)
		).length;

		const hasChild =
			relationshipList.some((relationship: any) => relationship.includes("child")) ||
			relationshipList.includes("children");

		const hasSpouse = relationshipList.includes("spouse");

		const onlyEDActive =
			planDetails?.ED?.active &&
			!planDetails?.ES?.active &&
			!planDetails?.EC?.active &&
			!planDetails?.ECH?.active;

		// only ED available
		if (onlyEDActive && relationshipList.length > 0) {
			coverage_code = "ED";
		}

		// spouse + child
		else if (hasSpouse && hasChild) {
			coverage_code = "EF";
		}

		// spouse only
		else if (hasSpouse) {
			coverage_code = planDetails?.ES?.active ? "ES" : planDetails?.ED?.active ? "ED" : "EE";
		}

		// multiple child
		else if (relationshipList.includes("children") || childCount > 1) {
			if (planDetails?.ECH?.active) {
				coverage_code = "ECH";
			} else if (planDetails?.EC?.active) {
				coverage_code = "EC";
			} else if (planDetails?.ED?.active) {
				coverage_code = "ED";
			}
		}

		// single child
		else if (hasChild && childCount === 1) {
			if (planDetails?.EC?.active) {
				coverage_code = "EC";
			} else if (planDetails?.ECH?.active) {
				coverage_code = "ECH";
			} else if (planDetails?.ED?.active) {
				coverage_code = "ED";
			}
		}

		// unknown
		else if (relationshipList.length > 0) {
			console.log("some critical relationship found not included in premium", relationshipList);
		}
		return coverage_code;
	}, []);
	const calculatePremium = useCallback(() => {
		if (!basePlanCoverage || !paycheck) {
			return null;
		}
		// if (!basePlanCoverage.has_premium) {
		// 	return null;
		// }
		// Null when the plan could not be resolved (a rider carries its own plan_name, which
		// matches no plan document). Guard rather than crashing the whole approval screen.
		if (basePlanCoverage.has_employee_custom_contribution) {
			if (enrollments) {
				setEmployeePremium(enrollments[0].premium_amount);
				return null;
			}
			return null;
		}
		if (!currentActivePlanDetails?.has_premium) {
			return null;
		}
		// VEB-structured plans have no core `coverage` (EE/ES/EC/ECH/ED) table — they are
		// priced from the VEB premium tables when the member enrols, and those amounts are
		// already stored on each enrollment row. Reuse them instead of re-pricing.
		if (currentActivePlanDetails?.same_as_veb_structure) {
			if (enrollments && enrollments.length > 0) {
				setEmployeePremium(enrollments[0].premium_amount);
			}
			return null;
		}
		let coveredChildren: Member[] = [];
		let { premium_without_dependent } = basePlanCoverage.coverage;

		let employeePremium: number | null = 0;
		let spousePremium: number | null = 0;
		let childPremium: number | null = 0;
		let childrenPremium: number | null = 0;

		const basePayRate = paycheck?.base_pay_rate;

		employeePremium = getPremiumAmountRateByCoverage(basePayRate, basePlanCoverage.coverage.EE);

		// childPremium = getPremiumAmountRateByCoverage(basePayRate, plan.coverage.EC);
		// childrenPremium = getPremiumAmountRateByCoverage(basePayRate, plan.coverage.ECH);

		let coveredSpouse: Member | null = null;
		// console.log("employeePremium=================> 3333", employeePremium);
		// employeePremium = calculatePremiumByCoverage(basePayRate, plan.coverage.EE);
		// console.log("employeePremium=================>", coveredDependents);
		if (employeePremium === null) {
			return;
		}
		coveredDependents.forEach((coveredDependent: Member) => {
			if (coveredDependent.relationship?.toLowerCase() === RELATIONSHIP.spouse.toLowerCase()) {
				coveredSpouse = coveredDependent;
			}
			// if (childrenRelationships.includes(coveredDependent.relationship as string))
			else {
				coveredChildren.push(coveredDependent);
			}
		});
		// console.log("premium", employeePremium);

		const standardDetails: StandardDetails[] = [];
		let _dependentPremium = 0;
		let baseEnrollmentPremium = employeePremium;

		const baseEnrollmentDetails: any = {};
		const riderEnrollmentDetails: any = {};
		console.log(enrollments, "test 2 3", riderEnrollments);

		if (enrollments && enrollments.length > 0) {
			baseEnrollmentDetails["sub_plan"] = enrollments[0].sub_plan;
			riderEnrollmentDetails["sub_plan"] = enrollments[0].sub_plan;
		}

		// if (riderEnrollments && riderEnrollments.length > 0) {
		// 	riderEnrollmentDetails["sub_plan"] = riderEnrollments[0].sub_plan;
		// 	riderEnrollmentDetails["plan_name"] = riderEnrollments[0].plan_name;
		// }
		// console.log("test 2 3 4", riderPlanCoverage);

		//  for base plan calculation
		if (premium_without_dependent) {
			if (coveredDependents.length !== 0) {
				if (coveredSpouse !== null) {
					const premiumAmount = getPremiumAmountRateByCoverage(
						basePayRate,
						basePlanCoverage.coverage.ED?.active
							? basePlanCoverage.coverage.ED
							: basePlanCoverage.coverage.ES
					);
					if (premiumAmount === null) {
						alert("Invalid Premium Amount");
						return null;
					}
					const spouseStandardDetails: StandardDetails = {
						member_object_id: coveredSpouse["_id"],
						coverage_code: "ES",
						member_SSN: coveredSpouse["SSN"],
						premium_amount: premiumAmount,
						...baseEnrollmentDetails,
						is_tobacco: false
					};
					standardDetails.push(spouseStandardDetails);
					_dependentPremium = _dependentPremium + premiumAmount;
					baseEnrollmentPremium = baseEnrollmentPremium + premiumAmount;
				}
				if (coveredChildren.length !== 0) {
					if (coveredChildren.length === 1) {
						const premiumAmount = getPremiumAmountRateByCoverage(
							basePayRate,
							basePlanCoverage.coverage.ED?.active
								? basePlanCoverage.coverage.ED
								: basePlanCoverage.coverage.EC
						);
						if (premiumAmount === null) {
							alert("Invalid Premium Amount");
							return null;
						}
						const childStandardDetails: StandardDetails = {
							member_object_id: coveredChildren[0]._id as string,
							coverage_code: "EC",
							member_SSN: coveredChildren[0].SSN,
							premium_amount: premiumAmount,
							...baseEnrollmentDetails,
							is_tobacco: false
						};
						_dependentPremium = _dependentPremium + premiumAmount;
						baseEnrollmentPremium = baseEnrollmentPremium + premiumAmount;
						standardDetails.push(childStandardDetails);
					} else {
						const premiumAmount = getPremiumAmountRateByCoverage(
							basePayRate,
							basePlanCoverage.coverage.ED?.active
								? basePlanCoverage.coverage.ED
								: basePlanCoverage.coverage.ECH
						);
						if (premiumAmount === null) {
							alert("Invalid Premium Amount");
							return null;
						}
						coveredChildren.forEach((coveredChild: Member) => {
							const childrenStandardDetails: StandardDetails = {
								member_object_id: coveredChild._id as string,
								coverage_code: "ECH",
								member_SSN: coveredChild.SSN,
								premium_amount: premiumAmount,
								...baseEnrollmentDetails,
								is_tobacco: false
							};
							standardDetails.push(childrenStandardDetails);
						});
						baseEnrollmentPremium = baseEnrollmentPremium + premiumAmount;
						_dependentPremium = _dependentPremium + premiumAmount;
					}
				}
				// console.log("standardDetails", standardDetails);
				// setDependentPremium(_dependentPremium);
			}
			// setTotalPremium(employeePremium + _dependentPremium);
			// setEmployeePremium(employeePremium);
		} else {
			// premium_without_dependent=false;
			// console.log("premium_without_dependent=====> 3333", premium_without_dependent);
			let premiumCoverage: any = null;
			if (
				basePlanCoverage.coverage?.ED?.active &&
				!basePlanCoverage.coverage?.ES?.active &&
				!basePlanCoverage.coverage?.EC?.active &&
				!basePlanCoverage.coverage?.ECH?.active
			) {
				// only ED available for dependents
				premiumCoverage = basePlanCoverage.coverage.ED;
			} else if (coveredSpouse && coveredChildren.length > 0) {
				premiumCoverage = basePlanCoverage.coverage.ED;
			} else if (coveredSpouse) {
				premiumCoverage = basePlanCoverage.coverage.ES;
				// } else if (coveredChildren.length > 0) {
				// 	// even 1 child uses ECH
				// 	premiumCoverage = basePlanCoverage.coverage.ECH;
				// } else {
				// 	premiumCoverage = basePlanCoverage.coverage.EE;
				// }
			} else if (coveredChildren.length > 0) {
				// child logic

				if (coveredChildren.length === 1) {
					// single child

					if (basePlanCoverage.coverage?.EC?.active) {
						premiumCoverage = basePlanCoverage.coverage.EC;
					} else if (basePlanCoverage.coverage?.ECH?.active) {
						premiumCoverage = basePlanCoverage.coverage.ECH;
					} else if (basePlanCoverage.coverage?.ED?.active) {
						premiumCoverage = basePlanCoverage.coverage.ED;
					}
				} else {
					// multiple child

					if (basePlanCoverage.coverage?.ECH?.active) {
						premiumCoverage = basePlanCoverage.coverage.ECH;
					} else if (basePlanCoverage.coverage?.EC?.active) {
						premiumCoverage = basePlanCoverage.coverage.EC;
					} else if (basePlanCoverage.coverage?.ED?.active) {
						premiumCoverage = basePlanCoverage.coverage.ED;
					}
				}
			} else {
				premiumCoverage = basePlanCoverage.coverage.EE;
			}
			let resolvedCoverageCode = "ED";

			if (coveredChildren.length === 1) {
				if (basePlanCoverage.coverage?.EC?.active) {
					resolvedCoverageCode = "EC";
				} else if (basePlanCoverage.coverage?.ECH?.active) {
					resolvedCoverageCode = "ECH";
				}
			} else if (coveredChildren.length > 1) {
				if (basePlanCoverage.coverage?.ECH?.active) {
					resolvedCoverageCode = "ECH";
				} else if (basePlanCoverage.coverage?.EC?.active) {
					resolvedCoverageCode = "EC";
				}
			}
			// console.log("premiumCoverage=====>", premiumCoverage);
			const premiumAmount = getPremiumAmountRateByCoverage(basePayRate, premiumCoverage);
			// console.log(resolvedCoverageCode, "premiumCoverage=====> 2222", premiumAmount);
			if (coveredDependents.length !== 0) {
				const flexb_coverage_code = calculateCombinedCoverageCode(coveredDependents, basePlanCoverage.coverage);
				// console.log("flexb_coverage_code=====>", flexb_coverage_code);
				// const totalPremium = getPremiumAmountRateByCoverage(
				// 	basePayRate,
				// 	basePlanCoverage.coverage.ED?.active
				// 		? basePlanCoverage.coverage.ED
				// 		: basePlanCoverage.coverage[flexb_coverage_code]
				// );
				if (totalPremium === null) {
					alert("Invalid Premium Amount");
					return null;
				}
				if (premiumAmount === null) {
					alert("Invalid Premium Amount");
					return null;
				}

				if (coveredSpouse !== null) {
					const spouseStandardDetails: StandardDetails = {
						member_object_id: coveredSpouse["_id"],
						// coverage_code: "ES",
						coverage_code: basePlanCoverage.coverage?.ES?.active ? "ES" : "ED",
						member_SSN: coveredSpouse["SSN"],
						flexb_coverage_code: flexb_coverage_code,
						// premium_amount: totalPremium,
						premium_amount: getPremiumAmountByCoverage(
							basePlanCoverage.coverage?.ES?.active
								? basePlanCoverage.coverage.ES
								: basePlanCoverage.coverage.ED
						),
						...baseEnrollmentDetails,
						is_tobacco: false
					};
					standardDetails.push(spouseStandardDetails);
				}
				if (coveredChildren.length !== 0) {
					if (coveredChildren.length === 1) {
						const childStandardDetails: StandardDetails = {
							member_object_id: coveredChildren[0]._id as string,
							// coverage_code: "EC",
							coverage_code: resolvedCoverageCode,
							member_SSN: coveredChildren[0].SSN,
							flexb_coverage_code: flexb_coverage_code,
							// premium_amount: totalPremium,
							premium_amount: getPremiumAmountByCoverage(basePlanCoverage.coverage[resolvedCoverageCode]),
							...baseEnrollmentDetails,
							is_tobacco: false
						};

						standardDetails.push(childStandardDetails);
					} else {
						coveredChildren.forEach((coveredChild: Member) => {
							const childrenStandardDetails: StandardDetails = {
								member_object_id: coveredChild._id as string,
								// coverage_code: "ECH",
								coverage_code: resolvedCoverageCode,
								member_SSN: coveredChild.SSN,
								flexb_coverage_code: flexb_coverage_code,
								// premium_amount: totalPremium,
								premium_amount: getPremiumAmountByCoverage(
									basePlanCoverage.coverage[resolvedCoverageCode]
								),
								...baseEnrollmentDetails,
								is_tobacco: false
							};
							standardDetails.push(childrenStandardDetails);
						});
					}
				}
				// baseEnrollmentPremium = totalPremium;
				// employeePremium = totalPremium;
				baseEnrollmentPremium = Number(premiumAmount);
				// employeePremium = Number(premiumAmount);
				// setTotalPremium(totalPremium);
				// setEmployeePremium(totalPremium);
				// console.log("standardDetails", standardDetails);
				// setDependentPremium(_dependentPremium);
			}
			// else {
			// 	setTotalPremium(employeePremium);
			// 	setEmployeePremium(employeePremium);
			// }
		}
		// for rider plan calculation
		coveredSpouse = null;
		coveredChildren = [];
		riderPlanCoveredDependents.forEach((coveredDependent: Member) => {
			if (coveredDependent.relationship?.toLowerCase() === RELATIONSHIP.spouse.toLowerCase()) {
				coveredSpouse = coveredDependent;
			}
			// if (childrenRelationships.includes(coveredDependent.relationship as string))
			else {
				coveredChildren.push(coveredDependent);
			}
		});
		let riderDependentPremium = 0;

		let riderEmployeePremium = 0;

		let riderTotalPremium = 0;
		// console.log("employeePremium=================> employeePremium", employeePremium, riderPlanCoverage);
		if (riderPlanCoverage) {
			// console.log("run for rider test 2 3 4 ", riderPlanCoveredDependents);
			({ premium_without_dependent } = riderPlanCoverage.coverage);
			riderEnrollmentDetails["plan_name"] = riderPlanCoverage.name;

			if (premium_without_dependent) {
				const premiumAmount = getPremiumAmountRateByCoverage(basePayRate, riderPlanCoverage.coverage.EE);
				// console.log("ttt", basePayRate, riderPlanCoverage.coverage);
				if (premiumAmount === null) {
					alert("Invalid Employee SubPlan Premium Amount");
					return null;
				}
				riderEmployeePremium = premiumAmount;
				riderTotalPremium = riderEmployeePremium;
				_dependentPremium = _dependentPremium + premiumAmount;
				const employeeStandardDetails: StandardDetails & any = {
					member_object_id: member?._id,
					coverage_code: "EE",
					member_SSN: member?.SSN,
					premium_amount: premiumAmount,
					...riderEnrollmentDetails,
					is_tobacco: false
					// plan_name: subPlan,
					// sub_plan: basePlan
				};
				standardDetails.push(employeeStandardDetails);
				if (riderPlanCoveredDependents.length !== 0) {
					if (coveredSpouse !== null) {
						const premiumAmount = getPremiumAmountRateByCoverage(
							basePayRate,
							riderPlanCoverage.coverage.ED?.active
								? riderPlanCoverage.coverage.ED
								: riderPlanCoverage.coverage.ES
						);
						if (premiumAmount === null) {
							alert("Invalid Premium Amount");
							return null;
						}
						const spouseStandardDetails: StandardDetails = {
							member_object_id: coveredSpouse["_id"],
							coverage_code: "ES",
							member_SSN: coveredSpouse["SSN"],
							premium_amount: premiumAmount,
							...riderEnrollmentDetails,
							is_tobacco: false
						};
						standardDetails.push(spouseStandardDetails);
						riderTotalPremium = riderTotalPremium + premiumAmount;
						_dependentPremium = _dependentPremium + premiumAmount;
					}
					if (coveredChildren.length !== 0) {
						if (coveredChildren.length === 1) {
							const premiumAmount = getPremiumAmountRateByCoverage(
								basePayRate,
								riderPlanCoverage.coverage.ED?.active
									? riderPlanCoverage.coverage.ED
									: riderPlanCoverage.coverage.EC
							);
							if (premiumAmount === null) {
								alert("Invalid Premium Amount");
								return null;
							}
							const childStandardDetails: StandardDetails = {
								member_object_id: coveredChildren[0]._id as string,
								coverage_code: "EC",
								member_SSN: coveredChildren[0].SSN,
								premium_amount: premiumAmount,
								...riderEnrollmentDetails,
								is_tobacco: false
							};
							riderTotalPremium = riderTotalPremium + premiumAmount;
							_dependentPremium = _dependentPremium + premiumAmount;
							standardDetails.push(childStandardDetails);
						} else {
							const premiumAmount = getPremiumAmountRateByCoverage(
								basePayRate,
								riderPlanCoverage.coverage.ED?.active
									? riderPlanCoverage.coverage.ED
									: riderPlanCoverage.coverage.ECH
							);
							if (premiumAmount === null) {
								alert("Invalid Premium Amount");
								return null;
							}
							coveredChildren.forEach((coveredChild: Member) => {
								const childrenStandardDetails: StandardDetails = {
									member_object_id: coveredChild._id as string,
									coverage_code: "ECH",
									member_SSN: coveredChild.SSN,
									premium_amount: premiumAmount,
									...riderEnrollmentDetails,
									is_tobacco: false
								};
								standardDetails.push(childrenStandardDetails);
							});
							riderTotalPremium = riderTotalPremium + premiumAmount;
							_dependentPremium = _dependentPremium + premiumAmount;
						}
					}
					// console.log("standardDetails", standardDetails);
					// setDependentPremium(_dependentPremium);
				}
				// setTotalPremium(employeePremium + _dependentPremium);
				// setEmployeePremium(employeePremium);
			} else {
				// const flexb_coverage_code = calculateCombinedCoverageCode(riderPlanCoveredDependents);
				const flexb_coverage_code = calculateCombinedCoverageCode(
					riderPlanCoveredDependents,
					riderPlanCoverage.coverage
				);
				const totalPremium = getPremiumAmountRateByCoverage(
					basePayRate,
					flexb_coverage_code != "EE"
						? riderPlanCoverage.coverage.ED?.active
							? riderPlanCoverage.coverage.ED
							: riderPlanCoverage.coverage[flexb_coverage_code]
						: riderPlanCoverage.coverage["EE"]
				);
				const employeeStandardDetails: StandardDetails & any = {
					member_object_id: member?._id,
					coverage_code: "EE",
					member_SSN: member?.SSN,
					premium_amount: totalPremium,
					...riderEnrollmentDetails,
					is_tobacco: false
					// plan_name: subPlan,
					// sub_plan: basePlan
				};
				standardDetails.push(employeeStandardDetails);
				if (riderPlanCoveredDependents.length !== 0) {
					if (totalPremium === null) {
						alert("Invalid Premium Amount");
						return null;
					}

					riderTotalPremium = totalPremium;
					riderEmployeePremium = totalPremium;

					if (coveredSpouse !== null) {
						const spouseStandardDetails: StandardDetails = {
							member_object_id: coveredSpouse["_id"],
							coverage_code: "ES",
							member_SSN: coveredSpouse["SSN"],
							flexb_coverage_code: flexb_coverage_code,
							premium_amount: totalPremium,
							...riderEnrollmentDetails,
							is_tobacco: false
						};
						standardDetails.push(spouseStandardDetails);
					}
					if (coveredChildren.length !== 0) {
						if (coveredChildren.length === 1) {
							const childStandardDetails: StandardDetails = {
								member_object_id: coveredChildren[0]._id as string,
								coverage_code: "EC",
								member_SSN: coveredChildren[0].SSN,
								flexb_coverage_code: flexb_coverage_code,
								premium_amount: totalPremium,
								...riderEnrollmentDetails,
								is_tobacco: false
							};

							standardDetails.push(childStandardDetails);
						} else {
							coveredChildren.forEach((coveredChild: Member) => {
								const childrenStandardDetails: StandardDetails = {
									member_object_id: coveredChild._id as string,
									coverage_code: "ECH",
									member_SSN: coveredChild.SSN,
									flexb_coverage_code: flexb_coverage_code,
									premium_amount: totalPremium,
									...riderEnrollmentDetails,
									is_tobacco: false
								};
								standardDetails.push(childrenStandardDetails);
							});
						}
					}
					// setTotalPremium(totalPremium);
					// setEmployeePremium(totalPremium);
					// console.log("standardDetails", standardDetails);
					// setDependentPremium(_dependentPremium);
				}
				// else {
				// 	setTotalPremium(employeePremium);
				// 	setEmployeePremium(employeePremium);
				// }
			}
		}
		// console.log("employeePremium=================>", employeePremium);
		setTotalPremium((baseEnrollmentPremium + riderTotalPremium).toFixed(2) as any);
		setEmployeePremium((employeePremium + riderEmployeePremium).toFixed(2) as any);
		setEnrollmentStandardDetails(Object.assign([], standardDetails));
		// if (premium_without_dependent) {

		// }
	}, [
		coveredDependents.length,
		riderPlanCoveredDependents.length,
		paycheck,
		coveredDependents,
		riderPlanCoveredDependents,
		basePlanCoverage,
		plan,
		getPremiumAmountRateByCoverage,
		calculateCombinedCoverageCode,
		member,
		enrollments?.length
	]);

	useEffect(() => {
		// console.log(riderPlanCoveredDependents, "riderPlanCoveredDependents.length", riderPlanCoveredDependents.length);
		calculatePremium();
	}, [
		calculatePremium,
		// riderEnrollments?.length,
		enrollments?.length,
		coveredDependents.length,
		riderPlanCoveredDependents.length,
		enrollments,
		coveredDependents,
		riderPlanCoveredDependents
	]);

	// useEffect(() => {
	// 	// console.log("coveredDependents.length", coveredDependents.length);
	// 	calculateRiderPremium();
	// }, [calculateRiderPremium, riderPlanCoveredDependents.length]);

	useEffect(() => {
		if (basePlanCoverage && paycheck) getCoverageDetails();
	}, [getCoverageDetails, basePlanCoverage, paycheck]);

	useEffect(() => {
		getAdminEnrollmentInitData();
	}, [getAdminEnrollmentInitData]);

	useEffect(() => {
		if (
			riderEnrollments &&
			riderEnrollments.length > 0 &&
			dependents &&
			member?.employee_SSN &&
			paycheck &&
			riderPlanCoverage &&
			currentActivePlanDetails
		) {
			console.log("object", riderPlanCoverage);
			getDependentsForRider(
				riderEnrollments,
				dependents,
				riderPlanCoverage,
				currentActivePlanDetails,
				member?.employee_SSN
			);
			getRiderPlanCoverageDetails(riderPlanCoverage.coverage);
		}
	}, [
		riderEnrollments,
		dependents,
		riderPlanCoverage,
		currentActivePlanDetails,
		paycheck,
		member?.employee_SSN,
		getRiderPlanCoverageDetails
	]);

	useEffect(() => {
		// console.log("getDependents called", enrollments, dependents, member?.employee_SSN, paycheck, basePlanCoverage);
		if (
			enrollments &&
			// dependents &&
			member?.employee_SSN &&
			paycheck &&
			basePlanCoverage
			// &&
			// currentActivePlanDetails?.dependent_eligibility.length > 0
		) {
			getDependents(enrollments, dependents, member?.employee_SSN, paycheck, basePlanCoverage);
		}
	}, [enrollments, dependents, member?.employee_SSN, paycheck, basePlanCoverage]);

	// console.log("currentActivePlandetails", effectiveDate, enrollmentDate);

	return (
		<>
			<Suspense fallback={<div />}>
				<div
					className={mode ? "" : "PDForm-container theme-container"}
					style={
						mode
							? {
									margin: "auto",
									marginTop: "2rem",
									marginBottom: "2rem",
									marginLeft: "1rem",
									marginRight: "1rem"
							  }
							: {}
					}
				>
					<Paper className="paper-container">
						<div className="header-image-container">
							<PlanHeader
								planCode={mode ? plan.plan_code : (queryPlanCode as string)}
								planName={mode ? plan.plan_name : (queryPlanName as string)}
								// planName="Payroll Deduction Form"
								// planLogo={helpingOurOwnLogo}
							/>
						</div>
						<div className="theme-plan-section-margin" />

						{enrollments &&
						enrollments.length > 0 &&
						enrollments[0].sub_plan &&
						enrollments[0].sub_plan.length > 0 ? (
							<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
								<div className="details-form-row">
									{/* <div className="details-form-label  required">Coverage Level</div> */}
									<div className="details-form-label  required">Base Plan</div>
									<Select
										value={enrollments[0].sub_plan}
										input={<CustomSelectInput />}
										style={{ width: "40%" }}
										name="basePlan"
										disabled={true}
									>
										<MenuItem value={enrollments[0].sub_plan} key={enrollments[0].sub_plan}>
											{enrollments[0].sub_plan}
										</MenuItem>
									</Select>
								</div>
							</Grid>
						) : (
							<></>
						)}
						<div>
							{plan?.form_design?.textual_details ? (
								<ReactQuill
									value={plan?.form_design?.textual_details}
									readOnly={true} // disables editing
									theme="bubble" // 'bubble' theme hides toolbar automatically
								/>
							) : null}
						</div>
						<div className="theme-plan-section-margin" />
						{/* <div className="details-form-row">
						<div className="details-form-label">Description (Textual Details)</div>
						<CustomInput value={plan.form_design.textual_details} />
					</div> */}

						{currentActivePlanDetails?.has_premium ? (
							<CoverageDetails coverageDetails={coverageDetails} titleHeader={"Base Plan"} />
						) : null}

						<div className="theme-plan-section-margin" />

						{currentActivePlanDetails?.dependent_eligibility?.length > 0 &&
						eligibleDependents.length > 0 ? (
							<CoveredDependents
								dependents={eligibleDependents}
								handleSelectDependent={handleSelectDependent}
							/>
						) : null}

						<div className="theme-plan-section-margin" />

						{riderPlanCoverageDetails && riderPlanCoverageDetails.length > 0 ? (
							<CoverageDetails
								coverageDetails={riderPlanCoverageDetails}
								titleHeader="Rider Plans"
								choosePlanText="Add your desired rider plan"
							/>
						) : null}

						<div className="theme-plan-section-margin" />
						{riderPlanEligibleDependents && riderPlanEligibleDependents.length > 0 ? (
							riderPlanEligibleDependents.length > 0 ? (
								<CoveredDependents
									dependents={riderPlanEligibleDependents}
									handleSelectDependent={(event, dependents) =>
										handleSelectDependentForRider(event, dependents)
									}
								/>
							) : null
						) : null}

						<div>
							<div className="details-form-row">
								<div className="details-form-label  required">Total Premium Amount</div>
								<CustomInput value={`$ ${mode === "view" ? 45 : totalPremium}`} disabled />
							</div>
						</div>
						<div className="theme-plan-icon-item-container">
							<div>
								<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
							</div>
							<div className="theme-plan-text">
								<strong>Note:</strong> Employee represents that this authorization is executed
								voluntarily and has been made as a conditional of his/her continued employment.
							</div>
						</div>
						<div className="theme-plan-option-content theme-plan-section-margin">
							<Checkbox defaultChecked style={{ paddingLeft: 0 }} />
							<p className="theme-plan-checkbox-label">
								{plainText.length > 0 ? (
									<ReactQuill
										value={formDeclaration}
										readOnly={true}
										theme="bubble"
										style={{
											overflow: "hidden",
											// padding: "4px"
											margin: "-15px",
											marginTop: "-10px"
										}}
									/>
								) : (
									<strong>
										I UNDERSTAND AND AGREE TO THE TERMS AND CONDITIONS STATED ABOVE AND AUTHORIZE
										THE&nbsp;PAYROLL DEDUCTIONS TO BE MADE AS INDICATED
									</strong>
								)}
							</p>
						</div>
						{/* <div className="theme-plan-section-margin" /> */}
						<Grid container className="theme-plan-section-margin">
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Signature</div>
									<CustomInput
										value={mode ? "preview" : member?.first_name + " " + member?.last_name}
										disabled
									/>
								</div>
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
								<div className="details-form-row">
									<div className="details-form-label  required">Date</div>
									{/* {approveHOOEnrollment ? (
									<CustomInput
										value={dateTimeZoneConverter(
											approveHOOEnrollment
												? new Date(enrollmentDate).toLocaleDateString()
												: getCurrentDate()
										)}
										disabled
									/>
								) : null} */}
									{/* <CustomInput value={dateFormateToMonthDayYear(enrollmentDate)} disabled /> */}
									<CustomInput value={enrollmentDate ? mongoDBDateParserToUSAFormat(enrollmentDate) : ""} disabled />
								</div>
							</Grid>
						</Grid>
						<div className="theme-plan-section-margin" />
						<div className="theme-plan-icon-item-container">
							<div>
								<EventNoteIcon className="event-icon" style={{ color: theme.primary_color }} />
							</div>
							<div className="theme-plan-text">
								<strong>Note:</strong> PLEASE MAIL THE COMPLETED DEDUCTION FORM TO BROOKSHARE BROTHERS
								HUMAN RESOURCE DEPARTMENT
							</div>
						</div>
						<div className="theme-plan-section-margin" />
						{/* {approveHOOEnrollment ? (
						<>
							<Suspense fallback={<div />}>
								<LazyApproveEnrollment
									handleApproveEnrollmentDateChange={handleApproveEnrollmentDateChange}
									enrollmentDate={enrollmentDate}
									approveEnrollment={approveHOOEnrollment}
									handleApproveEnrollmentChange={handleApproveHOOEnrollmentChange}
									validation={validation}
								/>
							</Suspense>
							<div className="theme-plan-section-margin" />
							<div className="enrollment-submit-button-container" id="enrollment-submit-button-container">
								<Button
									className="button-green"
									onClick={handleSubmitEnrollmentClick}
									variant="contained"
									style={{
										pointerEvents: "unset"
									}}
								>
									<span className="button-label-with-icon">Submit</span>
									<span>
										<SendIcon className="button-icon" />
									</span>
								</Button>
							</div>
						</>
					) : null} */}
						<div className="approve-active-enrollment">
							{enrollmentStatus == "ACTIVE" ? (
								<ApproveEnrollmentSection
									enrollmentDate={enrollmentDate}
									enrollmentStatus={enrollmentStatus}
									effectiveDate={effectiveDate}
									handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
								/>
							) : (
								<ApproveEnrollmentSection
									enrollmentDate={enrollmentDate ? mongoDBDateParserToUSAFormat(enrollmentDate) : ""}
									approveEnrollment={approveEnrollment}
									effectiveDate={effectiveDate}
									handleApproveEnrollmentChange={handleApproveEnrollmentChange}
									handleApproveEnrollmentDateChange={handleApproveEffectiveDateChange}
									validation={validation}
								/>
							)}
						</div>

						<div className="theme-plan-section-margin" />
						<Grid container>
							<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
							<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
								<Button
									style={{
										backgroundColor: "#44b700",
										color: "#ffff "
									}}
									disabled={mode === "view" ? true : false}
									onClick={handleSubmitEnrollmentClick}
								>
									<span className="button-label-with-icon">Submit</span>
									<span>
										<SendIcon className="button-icon" />
									</span>
								</Button>
							</Grid>
							<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
						</Grid>
					</Paper>
				</div>
			</Suspense>
			{isExistsModelOpen && (
				<ExistsEnrollmentModel
					onClose={() => {
						setIsExistsModelOpen(false);
						setPendingDeselectDependent(null);
						// Also need to uncheck the checkbox since user cancelled
						if (pendingDeselectDependent) {
							setEligibleDependents((prev) =>
								prev.map((dep) =>
									dep.SSN === pendingDeselectDependent.SSN ? { ...dep, covered: false } : dep
								)
							);
						}
					}}
					dependentData={existsDependentData}
					onConfirm={handleConfirmDeselect}
					isDeselecting={true}
				/>
			)}
			{isDependentExistsModelOpen && (
				<ExistsDependentModel
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default ApprovalPlanForm;
